import { checkedMapFromEntries } from "@aprao/common/src/map/checkedMapFromEntries.js";
import type { InterestPayoutType } from "@aprao/model/src/shapes/ShapeLender.js";

export const interestPayoutTypeLabels: ReadonlyArray<
  [InterestPayoutType, string]
> = [
  ["retained", "retained"],
  ["rolledUp", "rolled-up"],
  ["serviced", "serviced"],
];

export const labelByInterestPayoutTypeLabels = checkedMapFromEntries(
  interestPayoutTypeLabels,
);
